import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => ({
    windowWidth: window.innerWidth,
    scrollTop: 0,
  }),
  actions: {
    setWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    setScrollTop() {
      this.scrollTop = document.documentElement.scrollTop;
    },
  },
});
